import { useEffect } from 'react';
import styles from './Others.module.scss'
import { Card, Typography, Grid } from '@mui/material';
import CONSTANTS from "../../config/constants.json";


const AboutTemple = () => {
    useEffect(() => {
        window.scrollTo(0, 200); // Scroll to the top of the page
        // Find the specific heading element by its ID or class name
        const aboutTempleHeading = document.getElementById('aboutTempleHeading');
        if (aboutTempleHeading) {
            aboutTempleHeading.scrollIntoView({ behavior: 'smooth' }); // Scroll to the heading
        }
    }, []);
    const historicalInformation = (): React.ReactElement => {
        return (
            <>
                <Grid>
                    <Typography className={styles.headers}>HCCC Historical Information</Typography>
                </Grid>
                <Grid>
                    <Typography className={styles.infomationtypo}>
                        <span >1977</span>: HCCC was incorporated<br />
                        <span>1980 - 83</span>: Land acquired in Livermore<br />
                        <span>1983 – 86</span>: Interim Temple.<br />
                        <span>1984 - 85</span>: Idols donated by Tamil Nadu Govt. & TTD<br />
                        <span>1984 - 86</span>:
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Foundation stone laid by Sri. N.T. Rama Rao.</li>
                            <li className={styles.listtexth}>Shilpis arrive from India and major construction began.</li>
                            <li className={styles.listtexth}>Foundation ceremonies for cultural center by Pdt. Ravi Shankar and Ustad Ali Akbar Khan</li>
                        </ul>
                        <span>1986</span>: Kumbhabhishekam - July 13 <br />
                        <span>1992</span>: Enclosure and roof completed & Raja gopuram and other Gopurams completed<br />
                        <span>1997</span>: Assembly Hall inaugurated by Livermore City Councilman
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}> Inaugural concert by K.J. Yesudas & Party</li>
                        </ul>
                        <span>1998</span>: Mahakumbhabhishekam in July 5
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Dakshina Bhoomi purchased</li>
                        </ul>

                        <span>1999</span>: Poorva Bhoomi purchased<br />
                        <span>2001</span>: Temple Flooring completed<br />
                        <span>2002</span>: 25th Anniversary Celebrations<br />
                        <span>2003</span>: Endowment Fund Intiation.<br />
                        <span>2010</span>: Mahakumbhabhishekam II - June 16<br />
                        <span>2011</span>: Kanaka Durga Prayer Hall completion<br />
                        <span>2012</span>:
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}> Administrative Building Completion.</li>
                            <li className={styles.listtexth}>Multi-Purpose Building Completion.</li>
                            <li className={styles.listtexth}>Akella Annadana Kitchen Completion</li>
                        </ul>
                        <span>2013</span>:
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Lakireddy Auditorium Completion</li>
                            <li className={styles.listtexth}>East Parking Lot Completion</li>
                        </ul>
                        <span>2016</span>: Solar Project<br />
                        <span>2019</span>: Temple 33rd Anniversary<br />
                        <span>2022</span>: Mahakumbhabhishekam III July 10
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Panavattam in Shiva Shrine</li>
                            <li className={styles.listtexth}>Kohstha vigrahas for Balaji Shrine</li>
                            <li className={styles.listtexth}>Sri Chandikeshwara deity</li>
                            <li className={styles.listtexth}>new moola murthies of Sri Rama Parivar</li>
                            <li className={styles.listtexth}>gold plated Dwajasthambhas</li>
                            <li className={styles.listtexth}>Alaya Shikar Kalasha and Prabhavalis</li>
                        </ul>
                    </Typography>
                </Grid>
            </>
        )
    }
    return (
        <>
            <div className={styles.abouttempleTotalLayout}>
                <Card className={styles.cardContainer}>
                    <Grid sx={{ margin: "24px" }}>
                        <div>
                            <div className={styles.imageAndContent}>
                                <Typography className={styles.headers}>About Temple</Typography>
                                <img src="/images/AboutTempleSmall.svg" className={styles.image} />
                                <Typography sx={{ width: "500px" }} className={styles.content}>
                                    HCCC was established in1977 with the goal of offering religious services to Hindu Community. In the last 35 years the HCCC has evolve into an established institution as a place of worship with the needed services for the community.
                                </Typography>
                            </div>
                            {/* <Grid>
                                <Typography className={styles.headers} sx={{ marginTop: "24px" }}>
                                    HCCC Historical Information
                                </Typography>
                                <table className={styles.historycontainer}>
                                    <tr>
                                        <td className={styles.yearsstyles}>1977</td>
                                        <td className={styles.historyinfo}>HCCC was incorporated</td>
                                    </tr>
                                    <tr style={{ marginTop: "12px" }}>
                                        <td className={styles.yearsstyles}>1980-1983</td>
                                        <td className={styles.historyinfo}>Land acquired in Livermore 1983-1986: Interim Temple
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>1984-1985</td>
                                        <td className={styles.historyinfo}>Idols donated by Tamil Nādu Govt and TTD Loan Grant and Balaji Idols
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>1984-1986</td>
                                        <td className={styles.historyinfo}>Foundation stone laid by Sri. N.T. Rama Rao. · Shilpis arrive from India and major construction began. · Foundation ceremonies for cultural center by     Pdt. Ravi Shankar and Ustad Ali Akbar Khan
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className={styles.yearsstyles}>1986</td>
                                        <td className={styles.historyinfo}>Kumbhabhishekam - July 13
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>1992</td>
                                        <td className={styles.historyinfo}>Enclosure and roof completed & Raja gopuram and other Gopurams completed
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>1997</td>
                                        <td className={styles.historyinfo}>Assembly Hall inaugurated by Livermore City Councilman · Inaugural concert by K.J. Yesudas & Party.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>1998</td>
                                        <td className={styles.historyinfo}> Mahakumbhabhishekam in July 5 · Dakshina Bhoomi purchased
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>1999</td>
                                        <td className={styles.historyinfo}>Poorva Bhoomi purchased
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2001</td>
                                        <td className={styles.historyinfo}>Temple Flooring completed
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2002</td>
                                        <td className={styles.historyinfo}>25th Anniversary Celebrations & First Health Fair
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2003</td>
                                        <td className={styles.historyinfo}>Endowment Fund Intiation.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2010</td>
                                        <td className={styles.historyinfo}>Mahakumbhabhishekam II - June 16
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2011</td>
                                        <td className={styles.historyinfo}>Kanaka Durga Prayer Hall completion
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2012</td>
                                        <td className={styles.historyinfo}>Administrative Building completion · Multi-Purpose Building completion · Assembly Hall Extension in progress
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2016</td>
                                        <td className={styles.historyinfo}>Solar Project
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2019</td>
                                        <td className={styles.historyinfo}>Temple 33rd Anniversary
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.yearsstyles}>2022</td>
                                        <td className={styles.historyinfo}>Mahakumbhabhishekam III July 10
                                        </td>
                                    </tr>
                                </table>
                            </Grid> */}
                            {historicalInformation()}
                        </div>
                        <Grid className={styles.links}>
                            <Typography className={styles.headerlinks}>
                                Sthala Puraana (Temple Story) Of Shiva Vishnu Temple
                            </Typography>
                            <div className={styles.linkstyles}>
                                <span className={styles.linkText}>Link:</span> <a href={CONSTANTS.DOMAIN_URL +"/hints/content/html/2022/temple-history.pdf"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.linkscolor}>{CONSTANTS.DOMAIN_URL +"/hints/content/html/2022/temple-history.pdf"}</a>
                            </div>
                            <Typography className={styles.headerlinks} style={{ marginTop: "20px" }}>
                                HCCC History: Cars (Content Archival and Retrieval System)
                            </Typography>
                            <div className={styles.linkstyles}>
                                <span className={styles.linkText}>Link:</span> <a href='https://hccccars.org'
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.linkscolor}>https://hccccars.org</a>
                            </div>
                        </Grid>
                    </Grid>

                </Card>
            </div>
        </>
    )
}
export default AboutTemple;